import React from 'react'

type Scroll = { onUpdate: boolean; onMount: boolean }

type withScrollToTopProps = {}

type withScrollToTopState = {}

// ToDo look at using "document.body.scrollTop = document.documentElement.scrollTop = 0" instead

function withScrollToTop<props, state>(WrappedComponent: any, scroll: Scroll) {
  return class extends React.Component<
    withScrollToTopProps & props,
    withScrollToTopState & state
  > {
    scrollRef

    constructor(props) {
      super(props)
      this.scrollRef = React.createRef()
    }

    componentDidMount() {
      if (scroll && scroll.onMount) {
        this.scrollRef.current.scrollIntoView()
      }
    }

    componentDidUpdate() {
      if (scroll && scroll.onUpdate) {
        this.scrollRef.current.scrollIntoView()
      }
    }

    render() {
      return (
        <span ref={this.scrollRef}>
          <WrappedComponent {...this.props} />
        </span>
      )
    }
  }
}

export { withScrollToTop }
